export function BuildProgress({ label }: { label: string }) {
  return (
    <div className="publish-progress" role="status" aria-live="polite">
      <span className="progress-orbit" aria-hidden="true" />
      <div>
        <strong>{label}</strong>
        <p>Your current live app stays online until this version is ready.</p>
      </div>
    </div>
  );
}
